var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoricalRuns02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clock-rotate-left-light",
    d: "M32,132V48A16,16,0,0,0,0,48V176a16.047,16.047,0,0,0,16,16H144a16,16,0,0,0,0-32H53.6A223.928,223.928,0,0,1,256,32c123.7,0,224,100.3,224,224S379.7,480,256,480A223.675,223.675,0,0,1,76.8,390.4a16,16,0,1,0-25.6,19.2A255.445,255.445,0,0,0,256,512c141.4,0,256-114.6,256-256S397.4,0,256,0C159.6,0,75.7,53.3,32,132Zm224-4a16.047,16.047,0,0,0-16,16V256a16.059,16.059,0,0,0,4.7,11.3l80,80a15.981,15.981,0,0,0,22.6-22.6L272,249.4V144A16.047,16.047,0,0,0,256,128Z",
    fill: "#c9c9c9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoricalRuns02);
export default __webpack_public_path__ + "static/media/historical-runs-02.107bf7dadd72e4c1633cbb697ba689da.svg";
export { ForwardRef as ReactComponent };